"use strict";

import initModulesInScope from '@elements/init-modules-in-scope';

export function initInScope($scope) {
    // hässlicher quickfix, weil problem mit timing und dem teaserSlider.js. ist aber nur mobil.
    setTimeout(function(){
        $scope.find('.js-ajax-modal').on('click', function (e) {
            // console.log('cliiiick');

            let $ajaxModalTarget = $($(this).data('ajax-modal-target'));
            let ajaxModalUrl = $(this).data('ajax-modal-url');
            let $ajaxModalLoading = $ajaxModalTarget.find('.js-ajax-modal__loading');
            let $ajaxModalResult = $ajaxModalTarget.find('.js-ajax-modal__result');

            $ajaxModalLoading.attr('hidden', null);
            $ajaxModalResult.attr('hidden', 'hidden');

            let request = fetch(ajaxModalUrl, {
                method: 'post'
            });

            request.then(response => response.json())
                .then(result => {
                    if (result.success) {
                        $ajaxModalTarget.modal();

                        let content = result.content || result.html;

                        if (content) {
                            $ajaxModalResult.empty().append(content);
                            $ajaxModalResult.attr('hidden', null);
                            initModulesInScope($ajaxModalResult);
                        }
                    }

                    $ajaxModalLoading.attr('hidden', 'hidden');

                }).catch(e => {
                    console.warn(e);
                    $ajaxModalLoading.attr('hidden', 'hidden');
                    $ajaxModalResult.attr('hidden', 'hidden');
                }
            );
        });
    }, 1000);
}